<ion-card *ngIf="orderDocumentType" padding>
  <!--  <ion-icon name="custom-camera"></ion-icon>-->
  <ion-grid no-padding>
    <ion-row>
      <ion-col size="12" class="title-text" text-center>
        <ion-text color="dark"
          >Upload
          {{ dataMap[orderDocumentType]?.displayText }} document</ion-text
        >
      </ion-col>
      <ion-col size="12" class="sub-title-text" text-center margin-top>
        <ion-text color="medium"
          >Example of accepted
          {{ dataMap[orderDocumentType]?.displayText }}</ion-text
        >
      </ion-col>
      <ion-col size="12" class="sample-img" text-center>
        <ion-img
          [src]="dataMap[orderDocumentType]?.sampleImg"
          (click)="showImg(dataMap[orderDocumentType]?.sampleImg)"
        ></ion-img>
      </ion-col>
      <ion-col size="12" class="imp-note" margin-top>
        <ion-text>
          <span font-bold="">Important Note:</span>
          The image/document should be properly scanned and all the corner of
          the document should show. Upload
          <span font-bold="">high resolution</span> photo for approval.
        </ion-text>
      </ion-col>
      <ion-col size="12" text-center padding-top>
        <ion-button
          [disabled]="!canUploadDelete()"
          size="large"
          (click)="uploadClicked()"
        >
          <ion-icon name="cloud-upload"></ion-icon> &nbsp; Upload Document
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card>
